import { FunctionComponent } from 'react'

import config from '@config'
import EmbeddedContent from '@components/EmbeddedContent'

const {
  socialembeds: { twitterEmbedStaticPageUrl },
} = config

interface TwitterComponentProps {
  url: string
}

const TwitterComponent: FunctionComponent<TwitterComponentProps> = ({
  url,
}) => <EmbeddedContent url={`${twitterEmbedStaticPageUrl}${url}`} />

export default TwitterComponent
